<template lang="pug">
  .user-manage
    .container
      .row.justify-content-md-center
        .col-lg-7
          //- .text-center.m-4
          //-   img(src="/img/register/status_02.png")
          h1 支払方法選択
          p 支払方法をお選びください。
          .alert.alert-danger(v-if="message") {{ message }}
          .alert.alert-danger(v-if="errMessage") システムエラーが発生しました。
            div しばらく時間をおいてから再度お試しください。解決しない場合はお手数ですが
              router-link(to="/inquiry_form/input") こちら
              |よりをお問い合わせください。
          div.pt-3.pb-2.content-header(v-if="isFreeShow")
            div.mb-2
              span#month-cost.position-relative 月額300円(税込) 
              span#triangle.ml-2.mr-2
                i.fas.fa-caret-right
              span#free 初月無料
            div.explanation お支払方法のご登録から１ヶ月間無料！
            div.explanation （いつでも無料会員に変更可能です。）
            div.explanation
              small ※初月無料はお一人様一回まで。

          form.needs-validation.content-box.p-4(@submit="exec(true)" ref="form" method="POST" novalidate)
            .form-group
              label 支払方法
              br
              .form-check.pl-0
                input#payMethod1.form-check-input(type="radio" v-model="payMethod" name="payMethod" value="credit" )
                label.form-check-label.radio-label(for="payMethod1") カード
              .form-check.pl-0
                input#payMethod2.form-check-input(type="radio" v-model="payMethod" name="payMethod" value="docomo" )
                label.form-check-label.radio-label(for="payMethod2") docomo
              .form-check.pl-0
              //-   input#payMethod3.form-check-input(type="radio" v-model="payMethod" name="payMethod" value="auone" )
              //-   label.form-check-label.radio-label(for="payMethod3") au
              .form-check.pl-0
                input#payMethod4.form-check-input(type="radio" v-model="payMethod" name="payMethod" value="softbank2" )
                label.form-check-label.radio-label(for="payMethod4") SoftBank
            .form-group
              input.btn.btn-primary(type="submit" value="次へ" v-bind:disabled="isDisabled")
            input(type="hidden" name="pay_method" ref="payMethodHidden")
            input(type="hidden" name="merchant_id" value="74522")
            input(type="hidden" name="service_id" value="001")
            input(type="hidden" name="cust_code" ref="userId")
            input(type="hidden" name="order_id" ref="orderId")
            input(type="hidden" name="item_id" ref="itemId")
            input(type="hidden" name="item_name" ref="itemName")
            input(type="hidden" name="service_type" ref="serviceType")
            input(type="hidden" name="terminal_type" ref="terminalType")
            input(type="hidden" name="success_url" ref="successUrl")
            input(type="hidden" name="cancel_url" ref="cancelUrl")
            input(type="hidden" name="error_url" ref="errorUrl")
            input(type="hidden" name="pagecon_url" ref="pageconUrl")
            input(type="hidden" name="request_date" ref="requestDate")
            input(type="hidden" name="limit_second" value="600")
            input(type="hidden" name="sps_hashcode" ref="hashcode")
</template>

<script>
import { createHash } from 'crypto'
import axios from 'axios'

import {
  Config,
  CognitoIdentityCredentials
} from 'aws-sdk'
import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute
} from 'amazon-cognito-identity-js'

export default {
  data() {
    return {
      locale: '未回答',
      message: '',
      isDisabled: false,
      payMethod: '',
      isPrivate: true,
      checkinOpenRange: 'OPEN',
      recordOpenRange: 'OPEN',
      show1: false,
      show2: false,
      show3: false,
      errMessage: false,
      profileText:'',
      isFreeShow: false
    }
  },
  mounted() {
    //URL設定
    this.$refs.successUrl.value = location.origin + '/register_user/input'
    this.$refs.cancelUrl.value = location.origin + '/register_user/payment'
    this.$refs.errorUrl.value = location.origin + '/'
    this.$refs.pageconUrl.value = process.env.VUE_APP_API_GATEWAY + '/api-pay'

    //支払い情報取得
    const jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-user'
    axios.get(jsonUrl, {
      headers: {
        'Authorization': this.$user.idToken
      }
    })
    .then(async res => {
      //無料期間を利用できるかどうか
      if(res.data.payment == 'free') {
        this.isFreeShow = true
      }
    })
    .catch(err => {
      console.log(err)
    })

  },
  methods: {
    exec(isPay) {
      this.isDisabled = true

      this.messages = ''

      this.errMessage = false

      //エラー処理
      if (this.$refs.form.checkValidity() === false) {
        this.$refs.form.classList.add('was-validated')
        this.isDisabled = false
        return
      }

      //日付取得
      let date = new Date () 

      let year = date.getFullYear() 	// 年
      let month = ('0' + (date.getMonth() + 1)).slice(-2)	// 月
      let day = ('0' + date.getDate()).slice(-2) //日
      let hour = ('0' + date.getHours()).slice(-2) 	// 時
      let minute = ('0' + date.getMinutes()).slice(-2)	// 分
      let second = ('0' + date.getSeconds()).slice(-2) 	// 秒

      this.$refs.requestDate.value = '' + year + month + day + hour + minute + second

      //クレジット決済の場合
      if(this.payMethod == 'credit') {
        this.$refs.orderId.value = ''
        this.$refs.form.action = process.env.VUE_APP_PAY_CREDIT
        this.$refs.itemId.value = ''
        this.$refs.itemName.value = ''
        this.$refs.serviceType.value = ''
        this.$refs.terminalType.value = '0'
      }else {
        //キャリア決済の場合
        this.$refs.orderId.value = '' + year + month + day + hour + minute + second
        this.$refs.form.action = process.env.VUE_APP_PAY_CARRIER
        this.$refs.itemId.value = '001'
        this.$refs.itemName.value = 'plan1'
        this.$refs.serviceType.value = '0'
        this.$refs.terminalType.value = '0'
      }

      //Value設定
      this.$refs.payMethodHidden.value = this.payMethod
      this.$refs.userId.value = this.$user.userId

      // ハッシュ値設定
      this.createCheckHash(this.$refs.form)
    },
    //ハッシュ値生成
    createCheckHash(e) {
      const hash = process.env.VUE_APP_PAY_HASH 
      let str = ''
      e.children.forEach(elm => {
        if (elm.type !== 'hidden') return
        str += elm.value
      })
      let shasum = createHash('sha1')
      shasum.update(str + hash)
      this.$refs.hashcode.value = shasum.digest('hex')
    },
  },
  components: {
  },
}
</script>

<style lang="stylus" scoped>
.content-header
  background #0070C0
  color #fff
  text-align center
  #month-cost
    text-decoration-line line-through
    text-decoration-style double
    font-size 1.1rem
    line-height 1.8rem

  #triangle,#free
    color #FFFF00
    font-size 1.8rem
    font-weight 600
  .explanation
    font-size 0.9rem
    small
      font-weight 500

.content-box
  border solid 3px #0070C0

</style>